module.exports = __webpack_public_path__ + "media/video-y-fotografia-aerea_reel.98cdf99a.mp4";